@if ((loanService.application()?.applicants?.length ?? 0) > 0) {
  <h3 class="title">Grunduppgifter</h3>

  <!-- Applicants information -->
  <div class="multi-group-holder">
    @for (applicant of loanService.application()?.applicants; track $index) {
      <div class="group-holder">
        <h3
          class="subtitle initial">{{ $first ? 'Sökande' : 'Medsökande' }}</h3>
        <div class="subgroup-holder">
          <spb-kalp-item
            [textValue]="true"
            text="Namn"
            [value]="applicant.displayName || applicant.contact.name"/>
          <spb-kalp-item
            [textValue]="true"
            text="Telefon"
            [value]="applicant.contact.phone"/>
          <spb-kalp-item
            [textValue]="true"
            text="Epost"
            [value]="applicant.contact.email"/>
          <spb-kalp-item
            [textValue]="true"
            text="Personnummer"
            [value]="applicant.personNummer"/>
          @if (applicant.employer) {
            <spb-kalp-item
              [textValue]="true"
              text="Arbetsgivare"
              [value]="applicant.employer"/>
          }
          <spb-kalp-item
            [textValue]="true"
            format="boolean"
            text="A-kassa"
            [value]="applicant.akassa ? 'Ja' : 'Nej'"/>

          @if (applicant.uc?.spouse) {
            <spb-kalp-item
              [textValue]="true"
              text="Partner/make/maka"
              [value]="applicant.uc?.spouse"/>
          } @else if (applicant.spouse) {
            <!-- This if is legacy in 6 months from june 2025-->
            <spb-kalp-item
              [textValue]="true"
              text="Partner/sambo/make/maka"
              [value]="applicant.spouse"/>
          }
        </div>

        @if ($first) {
          <div class="subgroup-holder">
            <spb-kalp-item
              [textValue]="false"
              format="1.0-0"
              text="Sökt lånebelopp"
              [value]="loanService.application()?.property?.loanAmount"/>
            <spb-kalp-item
              [textValue]="false"
              format="1.0-0"
              text="KALP"
              [value]="loanService.application()?.kalp"/>
          </div>
        }
      </div>
    }
  </div>

  <div [style.max-width.px]="490" [style.word-break]="'break-word'">
    <h4>Övriga upplysningar</h4>
    <p>{{ loanService.application()?.otherInfo ?? '----' }}</p>
  </div>

  <!-- Applicants income information -->
  <div class="multi-group-holder">
    @for (applicant of loanService.application()?.applicants; track $index) {
      <div class="group-holder">
        <h3 class="subtitle">{{ $first ? 'Sökande' : 'Medsökande' }}</h3>
        <div class="error">
          @if (status().needsUCAboveThreshold || status().needsIncomeCheck) {
            <div class="error-info">
              @if (applicant.occupation === 4) {
                <p>OBS! Egenföretagare, inkomst kan skilja mot UC ({{ ucIncomes()[$index] }} kr) </p><p>Månadsinkomst
                  enligt kund:
                  {{ (+applicant.income) | number: '1.0-0' }} kr </p>
              } @else {
                <p>
                  Månadsinkomst enligt
                  UC: {{ ucIncomes()[$index] | number: '1.0-0' }} kr
                </p>

                <p>
                  Månadsinkomst enligt
                  kund: {{ (+applicant.income) | number: '1.0-0' }} kr
                </p>
              }
            </div>
          }

          @if (status().needsBlancoLoansThreshold || status().needsBlancoLoansMatchingUC) {
            <div class="error-info">
              <p>
                Privatlån enligt UC: {{ applicant.uc?.blancoLoans | number }} kr
              </p>

              @if ($index === 0) {
                <p>
                  {{ (loanService.application()?.applicants?.length ?? 0) > 1 ? 'Hushållets privatlån' : 'Privatlån' }}
                  enligt kund: {{ blancoLoans() | number }} kr
                </p>
              } @else {
                <p class="placeholder-row">&nbsp;</p>
              }
            </div>
          }

          <!--Housing loans compared to UC, needs to be divided by 2 if applicants have same amount-->
          @if (status().needsPropertyLoansMatchingUC) {
            <div class="error-info">
              @if ((loanService.application()?.applicants?.length ?? 0) > 1 && loanService.application()?.applicants?.[0]?.uc?.propertyLoans === loanService.application()?.applicants?.[1]?.uc?.propertyLoans) {
                <p>
                  Bostadslån enligt
                  UC: {{ ((applicant.uc?.propertyLoans ?? 0) / 2) | number }} kr
                  (delas av 2 låntagare)
                </p>
              } @else {
                <p>
                  Bostadslån enligt
                  UC: {{ applicant.uc?.propertyLoans | number }} kr
                </p>
              }

              @if ($index === 0) {
                <p>
                  {{ (loanService.application()?.applicants?.length ?? 0) > 1 ? 'Hushållets bostadslån' : 'Bostadslån' }}
                  enligt kund: {{ houseLoans() | number }} kr
                </p>
              } @else {
                <p class="placeholder-row">&nbsp;</p>
              }
            </div>
          }
        </div>
        <div class="subgroup-holder">
          <spb-kalp-item
            format="1.0-0"
            text="Inkomst"
            [value]="applicant.income"
            description=""/>
          <div class="error">{{ status().incomeDiffs[$index] }}
            @if (applicant.monthlyReducedIncome && applicant.monthlyReducedIncome !== applicant.income) {
              <p>
                Reducerad inkomst  {{ applicant.monthlyReducedIncome }}
              </p>
            }
          </div>

          @if (applicant.tax) {
            <spb-kalp-item
              format="1.0-0"
              text="Skatt"
              [value]="applicant.tax.tax"
              description=""/>
          }
          <spb-kalp-item
            [textValue]="true"
            text="Sysselsättning"
            [value]="applicant.occupation | occupationType"/>
          <spb-kalp-item
            format="1.0-0"
            text="Levnadsomkostnad"
            [value]="applicant.livingExpense"
            description=""/>
          @if (applicant.spouseExtraLivingExpense) {
            <spb-kalp-item
              format="1.0-0"
              text="Extra levnadsomkostnad (försörjningsplikt)"
              [value]="applicant.spouseExtraLivingExpense"
              description=""/>
          }
          @if (applicant.tax) {
            <spb-kalp-item
              format="1.0-0"
              text="Skattekolumn"
              [value]="applicant.tax.taxColumn"/>
            <spb-kalp-item
              format="2.2-3"
              suffix="%"
              text="Skatt i kommun"
              [value]="applicant.tax.taxValue"
              description=""/>

            @if (applicant.tax.taxPercent) {
              <spb-kalp-item
                format="2.2-3"
                suffix="%"
                text="Skatt i procent"
                [value]="applicant.tax.taxPercent"/>
            } @else {
              <spb-kalp-item
                [textValue]="true"
                text="Skatt i procent"
                value="-"/>
            }
          }

          <h4>Räntor</h4>
          @if (applicant.taxReduction) {
            <spb-kalp-item
              format="1.0-0"
              text="Ränta"
              [value]="applicant.taxReduction.interest"/>
            <spb-kalp-item
              format="1.0-0"
              text="Återbäring totalt (kr/år)"
              [value]="applicant.taxReduction.interestTaxReturn"/>
            <spb-kalp-item
              format="1.0-0"
              text="Återbäring 21% (kr/år)"
              [value]="applicant.taxReduction.lowReturn"/>
          }
        </div>
      </div>
    }
  </div>

  <!-- Children information -->
  <div class="group-holder">
    <h4>Barn</h4>
    <div class="subgroup-holder">
      <spb-kalp-item
        format="1.0-0"
        text="Antal barn"
        [value]="loanService.application()?.childrenCount"/>
      <spb-kalp-item
        format="1.0-0"
        text="Månadskostnad för barnomsorg"
        [value]="loanService.application()?.monthlyChildrenCareCost"/>
      <spb-kalp-item
        format="1.0-0"
        text="Total kostnad barn"
        [value]="loanService.application()?.childrenCost"/>
      <spb-kalp-item
        format="1.0-0"
        text="Barnbidrag"
        [value]="loanService.application()?.childrenBenefit"/>
      <spb-kalp-item
        format="1.0-0"
        text="Flerbarnstillägg"
        [value]="loanService.application()?.childrenBenefitExtra"/>
    </div>

    <div class="subgroup-holder">
      <div class="multi-group-holder">
        @for (child of loanService.application()?.children; track $index) {
          <div class="group-holder fitted">
            <div class="subgroup-holder">
              <spb-kalp-item
                format="1.0-0"
                [text]="$first ? 'Barn' : ''"
                [value]="$index + 1"/>
              <spb-kalp-item
                format="1.0-0"
                [text]="$first ? 'Ålder' : ''"
                [value]="child.age"/>
              <spb-kalp-item
                format="1.0-0"
                [text]="$first ? 'Kostnad' : ''"
                [value]="child.monthlyCost"/>
            </div>
          </div>
        }
      </div>
    </div>
  </div>

  <!-- Cars information -->
  <div class="group-holder">
    @if (loanService.application()?.cars) {
      <h4>Bil</h4>

      <div class="subgroup-holder">
        <spb-kalp-item
          format="1.0-0"
          text="Antal bilar"
          [value]="loanService.application()?.cars?.numOfCars"/>

        @for (car of loanService.application()?.cars?.individualCars; track $index) {
          <spb-kalp-item
            format="1.0-0"
            [text]="'Bil ' + ($index + 1)  + (car.carType === 'OWN' ? ' (ägd)' : ' (leasing)')"
            [value]="car.monthlyCost"/>
        }
      </div>
    }
  </div>
}